import { render, staticRenderFns } from "./MessageMultipleStoreTasks.vue?vue&type=template&id=4d532eee&"
import script from "./MessageMultipleStoreTasks.vue?vue&type=script&lang=js&"
export * from "./MessageMultipleStoreTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports